import { render, staticRenderFns } from "./PxfCb4xModal.vue?vue&type=template&id=05119b6e"
import script from "./PxfCb4xModal.vue?vue&type=script&lang=js"
export * from "./PxfCb4xModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports